var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWebDevelopment(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 3712.27 3158.64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1, .cls-2, .cls-3, .cls-4, .cls-5, .cls-6, .cls-7, .cls-8, .cls-9, .cls-10, .cls-11, .cls-12, .cls-13, .cls-14, .cls-15, .cls-16, .cls-17, .cls-18, .cls-19, .cls-20, .cls-21, .cls-22, .cls-23, .cls-24, .cls-25, .cls-26, .cls-27, .cls-28, .cls-29, .cls-30, .cls-31, .cls-32, .cls-33, .cls-34, .cls-35, .cls-36, .cls-37, .cls-38, .cls-39, .cls-40, .cls-41, .cls-42, .cls-43, .cls-44, .cls-45, .cls-46, .cls-47, .cls-48, .cls-49, .cls-50, .cls-51, .cls-52, .cls-53, .cls-54 {\n        stroke-width: 0px;\n      }\n\n      .cls-1, .cls-50 {\n        fill: #ccc;\n      }\n\n      .cls-2 {\n        fill: #c95d43;\n      }\n\n      .cls-3 {\n        fill: #4e4e4f;\n      }\n\n      .cls-4 {\n        fill: #fcfcfe;\n      }\n\n      .cls-5 {\n        fill: #ef9126;\n      }\n\n      .cls-6 {\n        fill: #0289c3;\n      }\n\n      .cls-7 {\n        fill: #fdfdff;\n      }\n\n      .cls-8 {\n        fill: #282828;\n      }\n\n      .cls-9 {\n        fill: #ececee;\n      }\n\n      .cls-10 {\n        fill: #f15a24;\n      }\n\n      .cls-11 {\n        fill: #c4c4c4;\n      }\n\n      .cls-55 {\n        isolation: isolate;\n      }\n\n      .cls-12 {\n        fill: #d24a43;\n      }\n\n      .cls-13 {\n        fill: #b3b3b3;\n      }\n\n      .cls-14 {\n        fill: #d9d9d9;\n      }\n\n      .cls-15 {\n        fill: #561e11;\n      }\n\n      .cls-16 {\n        fill: none;\n      }\n\n      .cls-17 {\n        fill: #303030;\n      }\n\n      .cls-18 {\n        fill: #524347;\n      }\n\n      .cls-19 {\n        fill: #f5cd17;\n      }\n\n      .cls-20 {\n        fill: #43aee4;\n      }\n\n      .cls-21 {\n        fill: #eda398;\n      }\n\n      .cls-22 {\n        fill: #ffb897;\n      }\n\n      .cls-23 {\n        fill: #e6e6e6;\n      }\n\n      .cls-24 {\n        fill: #999;\n      }\n\n      .cls-25 {\n        fill: #364049;\n      }\n\n      .cls-26 {\n        fill: #324644;\n      }\n\n      .cls-27 {\n        fill: #394149;\n      }\n\n      .cls-28 {\n        fill: #fb8057;\n      }\n\n      .cls-29 {\n        fill: #e1e1e1;\n      }\n\n      .cls-30 {\n        fill: #0073a0;\n      }\n\n      .cls-31 {\n        fill: #fba057;\n      }\n\n      .cls-32 {\n        fill: #484849;\n      }\n\n      .cls-33 {\n        fill: #ffcc97;\n      }\n\n      .cls-34 {\n        fill: #cbccd0;\n      }\n\n      .cls-35 {\n        fill: #e9998c;\n      }\n\n      .cls-36 {\n        fill: #262626;\n      }\n\n      .cls-37 {\n        fill: #a2a2a2;\n      }\n\n      .cls-38 {\n        fill: #e0232a;\n      }\n\n      .cls-39 {\n        fill: #d28a7e;\n      }\n\n      .cls-40 {\n        fill: #db2e2a;\n      }\n\n      .cls-41 {\n        fill: #f3eded;\n      }\n\n      .cls-42 {\n        fill: #3a3a3a;\n      }\n\n      .cls-43 {\n        fill: #50b09b;\n      }\n\n      .cls-44 {\n        fill: #333;\n      }\n\n      .cls-45 {\n        fill: #ff9e6a;\n      }\n\n      .cls-46 {\n        fill: #fff;\n      }\n\n      .cls-47 {\n        fill: #b90f0f;\n      }\n\n      .cls-48 {\n        fill: #5ccccc;\n      }\n\n      .cls-49 {\n        fill: #bec3c7;\n      }\n\n      .cls-50, .cls-56 {\n        mix-blend-mode: multiply;\n      }\n\n      .cls-51 {\n        fill: #e6978a;\n      }\n\n      .cls-52 {\n        fill: #ffbb6a;\n      }\n\n      .cls-53 {\n        fill: #de443a;\n      }\n\n      .cls-54 {\n        fill: #d8d8da;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-55"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Objects"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-50",
    d: "M3219.49,2731.29H733.97c-40.13,0-72.66-32.53-72.66-72.66V691.09h2558.18c40.13,0,72.66,32.53,72.66,72.66v1894.89c0,40.13-32.53,72.66-72.66,72.66Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M3242.15,1121.13H611.31v-392.39c0-48.41,39.24-87.66,87.66-87.66h2455.66c48.34,0,87.52,39.18,87.52,87.52v392.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-41",
    d: "M3169.49,2681.29H683.97c-40.13,0-72.66-32.53-72.66-72.66v-1487.5h2630.83v1487.5c0,40.13-32.53,72.66-72.66,72.66Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-46",
    x: 1204.51,
    y: 1511.17,
    width: 1410.94,
    height: 900.09
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-49",
    x: 1263.24,
    y: 1576.17,
    width: 1290.96,
    height: 153.32
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-48",
    x: 1773.04,
    y: 941.12,
    width: 352.64,
    height: 360.04,
    rx: 26.77,
    ry: 26.77
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-47",
    d: "M3242.15,798.96H611.31v-85.22c0-40.13,32.53-72.66,72.66-72.66h2485.52c40.13,0,72.66,32.53,72.66,72.66v85.22Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-49",
    x: 1263.24,
    y: 1793.34,
    width: 333.49,
    height: 333.49
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-49",
    x: 1669.36,
    y: 1793.34,
    width: 884.83,
    height: 50.1
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-49",
    x: 1669.36,
    y: 1886.31,
    width: 884.83,
    height: 50.1
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-49",
    x: 1669.36,
    y: 1979.27,
    width: 884.83,
    height: 50.1
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-49",
    x: 1669.36,
    y: 2072.24,
    width: 884.83,
    height: 50.1
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-49",
    x: 1263.24,
    y: 2185.07,
    width: 781.13,
    height: 52.76
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-49",
    x: 2363.38,
    y: 2171.37,
    width: 190.82,
    height: 190.82
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-49",
    x: 2111.78,
    y: 2171.37,
    width: 190.82,
    height: 190.82
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-49",
    x: 1268.52,
    y: 2270.4,
    width: 775.84,
    height: 92.59
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-19",
    cx: 2833.05,
    cy: 720.02,
    r: 45.99
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-46",
    cx: 2964.28,
    cy: 719.19,
    r: 45.99
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-43",
    cx: 3097.92,
    cy: 719.19,
    r: 45.99
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-50",
    points: "2444.13 2328.31 2815.21 3017.48 2960.11 2872.57 3178.79 3091.24 3207.07 3062.96 2988.4 2844.29 3133.3 2699.38 2444.13 2328.31"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-42",
    points: "2444.13 2233.13 2815.21 2922.3 2960.11 2777.39 3178.79 2996.06 3207.07 2967.78 2988.4 2749.11 3133.3 2604.2 2444.13 2233.13"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-50",
    cx: 994.75,
    cy: 1597.56,
    rx: 210.08,
    ry: 32
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-51",
    x: 934.36,
    y: 657.49,
    width: 72.44,
    height: 74.54
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-51",
    d: "M950.87,379.3c94.78-59.82,200.51,4.22,232.28,42.35,30.95,37.14-1.72,94.21-1.72,94.21-6.33,21.84-6.92,27.17-6.92,27.17-1.02,9.66,1.67,16.36,7.97,19.33l34.12,16.1c5.32,2.51,5.17,10.12-.24,12.43l-63.87,27.17c-9.34,3.97-16.96,11.14-21.49,20.22l-22.06,44.18c-13.34,26.73-22.12,38.62-51.92,36.48-27.33-1.97-103.96-24.3-137.88-84.33,0,0-112.28-164.43,31.72-255.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M1144.16,530.27c-3.68,8.31,2.05,17.55,11.14,17.93,5.05.21,9.92-2.82,11.97-7.43,3.68-8.31-2.05-17.55-11.14-17.93-5.05-.21-9.92,2.81-11.97,7.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-53",
    d: "M1061.05,557.92c-8.8,21.28,5.65,44.55,28.63,46.09,13.91.93,27.25-7.35,32.58-20.23,8.8-21.28-5.65-44.55-28.63-46.09-13.91-.93-27.25,7.35-32.58,20.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M1131.37,641.78c-18.45-8-32.21-25.25-35.9-45.03l3.55-.66c3.48,18.6,16.43,34.83,33.79,42.36l-1.45,3.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M1131.66,519.25c.86-6.95,5.53-13.37,11.89-16.34,6.35-2.97,14.25-2.44,20.16,1.37l-1.97,3.04c-4.88-3.13-11.4-3.59-16.67-1.13-5.24,2.45-9.1,7.75-9.82,13.5l-3.59-.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M915.46,633.24c9.03-21.68,28.16-37.44,47.9-50.16,19.74-12.72,41.01-23.5,58.15-39.56,17.14-16.06,30.49-39.77,27.06-63.01,12.77,3.53,27.03,1.27,38.07-6.05,11.05-7.32,12.86-17.24,14.6-30.38,14.79,8.48,32.75,11.27,49.42,7.69,10.84-2.33,18.6-12.59,27.91-14.93,10.5-2.64,21.21,4.38,33.12-.92,38.24-17.02,18.98-56.92-4.36-77.13-11.87-10.27-48.92-24.35-58.41-3.11-12.89-24.71-35.62-44.73-62.49-52.13-26.87-7.39-56.74-3.12-80.45,11.52-10.89-12.61-31.42-17.56-47.16-12.08-10.44,3.63-19.11,11.33-25.54,20.32-6.43,8.99-10.81,19.27-14.7,29.62-19.18-1.37-38.48,6.36-49.4,22.17-10.93,15.82-14.85,35.63-14.5,54.85.35,19.22,4.67,38.12,8.97,56.86-2.56-6.14-12.91-4.06-16.67,1.43-3.76,5.49-3.05,12.8-1.87,19.34,8.73,48.66,32.29,94.12,70.37,125.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-51",
    d: "M1004.15,502.49c-7.58-3.23-17.31-.15-21.64,6.87s-2.74,17.09,3.54,22.42c-7.71,4.16-11.95,10.59-12.94,19.3-1,8.7,2.49,17.8,9.06,23.6-.71-.31-1.43-.63-2.14-.94-3.86,3.55-4.55,6.76-8.41,10.31-6.06-13.07-12.44-25.34-18.5-38.4-5.48-11.81-11.03-23.87-12.59-36.79-1.56-12.93,1.49-27.1,11.03-35.97,9.44-8.78,24.58-10.73,35.93-4.62,11.35,6.11,18.81,21.51,16.68,34.22Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-18",
    points: "1175.05 596.01 1168.4 593.69 1197.78 509.31 1204.43 511.64 1175.05 596.01"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-18",
    x: 1089.79,
    y: 438.36,
    width: 7.06,
    height: 188.11,
    transform: "translate(240.59 1399.41) rotate(-71.44)"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-35",
    points: "1405.97 764.86 1421.69 763.21 1425.19 775.73 1474.48 789.17 1469 815.9 1422.54 824.35 1396.64 825.91 1387.02 783.06 1405.97 764.86"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "1386.93 783.14 1387.02 783.06 1396.64 825.91 1396.27 825.83 1373.07 832.7 1365.35 785.96 1386.93 783.14"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "1125.73 782.68 1365.35 785.96 1373.07 832.7 1118.16 871.43 905.74 821.43 905.74 732.02 1125.73 782.68"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "1138.6 1568.75 1096.44 1238.5 1074.75 1067.66 928.79 1092.08 991.78 1256.01 1065.12 1581.05 1070.49 1604.86 1182.11 1586.19 1138.6 1568.75"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-42",
    points: "888.43 1578.66 977.78 1257.94 1024.1 1092.08 880.11 1057.92 874.53 1233.45 815.94 1561.46 811.64 1585.5 921.76 1611.62 888.43 1578.66"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-44",
    points: "1086.59 1109.53 854.58 1109.53 903.12 967.65 905.74 732.02 1035.35 732.02 1065.12 899.78 1086.59 1109.53"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "1012.14 732.02 1062.02 899.78 1034.17 732.02 1012.14 732.02"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-38",
    points: "1062.02 899.78 1042.72 834.87 1033.61 764.69 1027.49 749.86 1020.01 758.48 1034.17 732.02 1062.02 899.78"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "1063.15 927.2 1001.74 801.09 1009.98 785.34 990.03 785.34 992.1 731.89 999.16 732.16 997.36 778.29 1021.63 778.29 1009.65 801.2 1069.49 924.12 1063.15 927.2"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-30",
    x: 1285.11,
    y: 618.56,
    width: 87.63,
    height: 734.74
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 1372.74,
    y: 618.56,
    width: 87.63,
    height: 734.74
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-20",
    x: 1460.36,
    y: 618.56,
    width: 87.63,
    height: 734.74
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-29",
    x: 1460.36,
    y: 485.21,
    width: 87.63,
    height: 133.36
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-11",
    x: 1372.74,
    y: 485.21,
    width: 87.63,
    height: 133.36
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-37",
    x: 1285.11,
    y: 485.21,
    width: 87.63,
    height: 133.36
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M1416.57,300.23c-1.43-.16-2.87-.24-4.3-.24h87.63c26.53,0,48.12,21.51,48.12,48.11v137.1h-87.63v-137.1c0-25.17-19.28-45.73-43.81-47.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-28",
    d: "M1333.25,300h79.02c1.44,0,2.87.08,4.3.24-24.61,2.15-43.81,22.7-43.81,47.88v137.1h-87.63v-137.1c0-26.61,21.51-48.11,48.12-48.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-45",
    d: "M1416.57,300.23c24.54,2.15,43.81,22.7,43.81,47.88v137.1h-87.63v-137.1c0-25.17,19.2-45.73,43.81-47.88Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-52",
    d: "M1457.6,1368.67c1.83-4.78,2.79-9.96,2.79-15.37l-2.79,15.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-52",
    d: "M1375.55,1368.67l-2.79-15.37c0,5.42.96,10.6,2.79,15.37Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "1398.31 1492.79 1416.56 1592.29 1416.55 1592.36 1398.3 1492.79 1398.31 1492.79"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "M1434.82,1492.79h36.49l76.71-139.49c0-24.22-19.68-43.81-43.81-43.81s-43.81,19.6-43.81,43.81l-25.57,139.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M1471.3,1492.79h-.08c.08-.32.08-.72.08-1.04,0-9.96-8.13-18-18.24-18s-18.32,8.05-18.32,18c0,.32,0,.72.08,1.04l-18.24,99.5,54.73-99.5Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-33",
    points: "1416.57 1592.33 1416.55 1592.36 1416.56 1592.29 1416.57 1592.33"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-52",
    d: "M1372.76,1353.3l2.63,14.42.16.95,2.63,14.5,20.15,109.61h36.49l25.57-139.49c0-24.22-19.68-43.81-43.81-43.81s-43.81,19.6-43.81,43.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-24",
    d: "M1398.17,1491.75c0,.32,0,.72.16,1.04l18.24,99.5,17.45-95.19q0-.08.08-.16l.64-3.82c0-.08.08-.24,0-.32.08-.32.08-.72.08-1.04,0-9.96-8.13-18-18.24-18s-18.4,8.05-18.4,18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-24",
    d: "M1434.74,1492.79c.08.08,0,.24,0,.32l.08-.32h-.08Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-52",
    points: "1416.57 1592.36 1416.57 1592.33 1416.59 1592.29 1416.57 1592.36"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-52",
    points: "1434.8 1492.79 1434.84 1492.79 1416.59 1592.29 1416.57 1592.33 1416.56 1592.29 1434.8 1492.79"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M1285.13,1353.3l76.63,139.49h36.56l-20.15-109.61-2.63-14.5-.16-.95-2.63-14.42c0-24.22-19.68-43.81-43.81-43.81s-43.81,19.6-43.81,43.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M1361.69,1491.75c0,.32,0,.72.08,1.04l54.81,99.5-18.24-99.5h-.64c.08-.32.08-.72.08-1.04,0-9.96-8.05-18-18-18s-18.08,8.05-18.08,18Z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-42",
    points: "990.03 732.02 905.74 729.92 904.71 824.54 1106.05 1008.23 1124.86 934.9 990.03 732.02"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-51",
    points: "1350.18 885.42 1373.07 896.05 1416.56 891.4 1396.64 934.9 1338.6 950.56 1323.38 909.37 1350.18 885.42"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "1323.3 909.46 1323.38 909.37 1338.6 950.56 1338.22 950.54 1316.13 960.42 1302.29 915.11 1323.3 909.46"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-42",
    points: "1302.29 915.11 1124.86 934.9 1106.05 1008.23 1316.13 960.42 1302.29 915.11"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M3044.85,1187.74c.84-3.59,2.14-7.17,4.56-9.94,2.43-2.77,6.16-4.61,9.79-4.01,4.61.77,7.77,5.04,9.77,9.25,3.7,7.77,5.2,16.58,4.28,25.14-6.43-10.08-16.81-17.55-28.41-20.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M3097.92,1177.52c-8.06-12.79-26.13-18.1-39.82-11.69-3.06,4.64-5.67,9.86-2.12,14.15,14.85-3.8,26.8-4.76,41.95-2.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M2807.79,1172.5c-11.24,5-18.02,18.43-15.35,30.45-6.63-7.27-10.42-15.66-8.36-25.28,2.06-9.63,8.98-18.08,18-22.01,2.41,5.08,3.3,11.76,5.71,16.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M3009.97,943.95c0,51.97-36.65,109.34-81.87,109.34s-81.87-57.36-81.87-109.34,36.65-78.88,81.87-78.88,81.87,26.91,81.87,78.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-53",
    d: "M3018.18,938.27c-22.33-22.43-53.26-36.07-84.88-37.45-31.62-1.38-63.62,9.52-87.82,29.91,55.2-23.84,119.32-20.14,172.7,7.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M3093.94,1062.94c.6,91.12-56.55,180.7-159,181.37-102.45.67-174.98-87.82-175.57-178.94-.6-91.12,65.21-147.92,167.66-148.59,102.45-.67,166.32,55.03,166.91,146.16Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-51",
    x: 2904.34,
    y: 1272.76,
    width: 45.95,
    height: 74.94
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-51",
    d: "M3081.91,1077.3c0,88.34-69.08,201.18-154.3,201.18s-154.3-112.84-154.3-201.18,69.08-118.72,154.3-118.72,154.3,30.38,154.3,118.72Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-26",
    cx: 2961.56,
    cy: 1100.2,
    r: 15.89,
    transform: "translate(1401.17 3847.29) rotate(-80.78)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-26",
    cx: 2892.38,
    cy: 1100.93,
    r: 15.89,
    transform: "translate(1342.36 3779.61) rotate(-80.78)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-53",
    cx: 2995.26,
    cy: 1147.04,
    r: 29.72,
    transform: "translate(1383.24 3919.89) rotate(-80.78)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-53",
    cx: 2856.35,
    cy: 1147.04,
    r: 29.72,
    transform: "translate(1266.58 3782.77) rotate(-80.78)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M2927.02,1196.16h-.53c-14.44,0-26.14-11.7-26.14-26.14v-24.27c17.6,9.71,35.2,9.71,52.81,0v24.27c0,14.44-11.7,26.14-26.14,26.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M2929.05,1146.83l-2.89-2.22,12.41-16.16c.65-.84.76-1.93.28-2.89-.47-.95-1.4-1.53-2.47-1.53h-7.89l-3.56-42.4,3.64-.29,3.26,39.06h4.55c2.46,0,4.65,1.37,5.74,3.56,1.08,2.2.83,4.78-.67,6.72l-12.41,16.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M3059.18,992.44c-16.39-18.18-35.02-25.74-63.28-36.17-19.67-7.26-63.37-7.26-63.37-7.26,0,0-50.92,2.17-72.23,6.62-29.48,6.17-46.89,17.99-63.28,36.17-22.06,24.48-29.47,59.47-26.86,92.32,2.61,32.85,15.14,63.92,27.33,94.54,12.96-23.07,16.19-50.6,13.85-76.95-2.35-26.36-7.14-51.14-14.69-76.5,31.18-30.93,81.02-42.08,125.71-39.31,0,0,92.26-3.86,137.19,39.95-7.54,25.36-12.34,50.15-14.69,76.5-2.35,26.36.88,53.89,13.85,76.95,12.18-30.62,24.72-61.69,27.33-94.54,2.61-32.85-4.8-67.85-26.86-92.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-51",
    d: "M2738.6,1119.28c6.57,14.84,16.22,28.6,28.33,40.37,3.12,3.04,6.5,6,10.66,7.8s9.31,2.26,13.37.28c6.49-3.15,7.86-10.82,7.85-17.39-.05-19.89-6.04-39.74-17.21-56.98-6.08-9.39-15.91-18.94-28.05-17.9-9.95.85-17.59,9.11-19.47,17.83-1.88,8.73.85,17.72,4.51,25.98Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-51",
    d: "M3116.04,1119.28c-6.57,14.84-16.22,28.6-28.33,40.37-3.12,3.04-6.5,6-10.66,7.8-4.17,1.79-9.31,2.26-13.37.28-6.49-3.15-7.86-10.82-7.85-17.39.05-19.89,6.04-39.74,17.21-56.98,6.08-9.39,15.91-18.94,28.05-17.9,9.95.85,17.59,9.11,19.47,17.83,1.88,8.73-.85,17.72-4.51,25.98Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M2795.03,1021.24c-13.47-15.61-36.2-22.54-56.09-17.11,3.67-11.56,11.6-21.07,23.52-23.34,11.92-2.27,24.9,2.47,32.56,11.88,6.82,8.37,8.72,21.93.99,29.47-.03.4-.95-1.31-.98-.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M2760.24,968.38c21.18,6.52,36.68,28.18,36,50.34,5.27-7.12,5.39-17.38,6.09-26.21.64-8.07-.9-16.49-5.45-23.19-4.55-6.7-12.34-11.4-20.43-11.14-8.09.26-14.61,2.27-16.22,10.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M3119.36,1015.72c-20.04-8.14-44.34-4.67-61.29,8.77-.07.82-.14,1.65-.21,2.47,5.57-17.45,20.64-33.11,38.91-31.76,11.52.85,21.35,9.03,22.59,20.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M2979.79,1070.7c-3.28-5.78-9.69-9.7-16.31-9.99-6.83-.19-13.37,3.03-17.16,8.49l-3.42-2.37c4.58-6.6,12.59-10.77,20.76-10.27,8.02.35,15.76,5.1,19.74,12.1l-3.62,2.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M2873.52,1070.73l-3.62-2.04c3.95-7,11.69-11.76,19.72-12.13,7.93-.44,16.17,3.64,20.76,10.23l-3.4,2.38c-3.8-5.45-10.43-8.68-17.17-8.46-6.64.31-13.04,4.24-16.3,10.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M2974.04,1091.65c-1.59,0-3.18-.25-4.69-.77l-5.07-1.76,4.93-2.11c2.98-1.29,5.06-6.47,3.98-9.89l3.95-1.26c1.21,3.79.15,8.4-2.23,11.61,1.8-.14,3.58-.74,5.08-1.75,2.65-1.81,4.4-4.94,4.55-8.17l4.15.2c-.21,4.5-2.64,8.88-6.37,11.42-2.43,1.63-5.36,2.49-8.28,2.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M2878.18,1092.7c-.75,0-1.52-.04-2.33-.12-4.3-.38-8.4-2.7-10.96-6.19l3.34-2.46c1.87,2.54,4.85,4.23,7.99,4.52,2.03.18,3.79.11,5.28-.28-4.32-2.68-7.09-7.8-6.51-12.98l4.13.47c-.52,4.63,3.06,9.38,7.65,10.17l4.09.7-3.02,2.86c-2.32,2.19-5.56,3.3-9.66,3.3Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    className: "cls-56"
  }, /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-1",
    cx: 2930.98,
    cy: 2198.94,
    rx: 205.29,
    ry: 31.27
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "2873.99 2174.07 2893.75 2134.41 2818.7 1621.4 2979.05 1621.4 2919.94 2137.15 2888.78 2174.07 2873.99 2174.07"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-25",
    points: "2888.78 2174.07 2919.94 2137.15 2919.94 2200.14 2913.9 2200.14 2913.9 2159.34 2891.52 2200.14 2861.01 2200.14 2873.99 2174.07 2888.78 2174.07"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "2856.89 2087.66 2953.13 2115.13 2932.27 2067.32 2988.03 1635.05 2818.7 1635.05 2877.14 2068.48 2856.89 2087.66"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-35",
    points: "2988.68 2174.07 2968.92 2134.41 3043.97 1621.4 2883.62 1621.4 2942.73 2137.15 2973.89 2174.07 2988.68 2174.07"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-25",
    points: "2973.89 2174.07 2942.73 2137.15 2942.73 2200.14 2948.77 2200.14 2948.77 2159.34 2971.15 2200.14 3001.66 2200.14 2988.68 2174.07 2973.89 2174.07"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-42",
    points: "3001.66 2104.02 2921.64 2122.34 2932.27 2081.59 2878.07 1635.05 3043.15 1635.05 2988.03 2087.66 3001.66 2104.02"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-44",
    points: "2821.21 1312.7 2787.37 1290.45 2754.57 1326.25 2754.57 1364.33 2690.34 1520.28 2764.62 1555.59 2822.98 1391.49 2821.21 1312.7"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-44",
    points: "3067.17 1635.05 2951.9 1692.26 2928.37 1635.05 2902.58 1692.26 2799.06 1643.48 2841.08 1472.56 2787.07 1407.32 2823.09 1312.7 3031.05 1312.7 3073.06 1402.3 3020.92 1475.96 3067.17 1635.05"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "2961.99 1312.7 2926.96 1441.96 2894.75 1313.34 2894.75 1286.7 2961.99 1286.7 2961.99 1312.7"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-27",
    points: "2927.33 1479.75 2838.81 1367.68 2875.21 1367.68 2847.36 1355 2860.2 1311.63 2867.46 1313.78 2856.48 1350.84 2910.11 1375.24 2854.44 1375.24 2927.33 1467.54 3000.22 1375.24 2944.55 1375.24 2998.17 1350.84 2987.19 1313.78 2994.45 1311.63 3007.3 1355 2979.44 1367.68 3015.84 1367.68 2927.33 1479.75"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "cls-27",
    cx: 2907.71,
    cy: 1524.16,
    r: 12.61
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-27",
    cx: 2953.13,
    cy: 1524.16,
    r: 12.61
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-27",
    cx: 2909.03,
    cy: 1572.08,
    r: 12.61
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-27",
    cx: 2954.45,
    cy: 1572.08,
    r: 12.61
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M2778.09,1474.95l-142.96-159.12c-5.74-6.39-15.56-11.58-21.93-11.6h3.45c6.37.03,16.19,5.22,21.93,11.61l142.96,159.12c5.74,6.39,5.23,11.55-1.14,11.54h-3.45c6.37,0,6.89-5.16,1.15-11.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M2505.17,1303.94h3.45s104.59.3,104.59.3c6.37.02,16.19,5.21,21.93,11.6l142.96,159.12c5.74,6.39,5.23,11.55-1.15,11.54l-104.59-.29h-3.45c-6.37-.03-16.19-5.22-21.93-11.61l-142.96-159.12c-5.74-6.39-5.23-11.55,1.15-11.53Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M2620.27,1395.15c8.73,9.71,23.65,17.61,33.34,17.63,9.69.03,10.47-7.82,1.74-17.54-8.73-9.71-23.65-17.61-33.34-17.63s-10.47,7.82-1.74,17.54Z"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-21",
    points: "2764.62 1555.59 2764.62 1510.88 2625.72 1381.97 2609.27 1370.22 2591.06 1339.76 2574.84 1341.42 2587.42 1391.07 2611.74 1402.69 2713.97 1555.63 2764.62 1555.59"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-53",
    d: "M2939.96,1519.96l-20.4-6.54c-.44-.14-.91-.14-1.35,0l-20.4,6.54c-.91.29-1.53,1.14-1.53,2.1v70.63c0,1.22.99,2.21,2.21,2.21h40.81c1.22,0,2.21-.99,2.21-2.21v-70.63c0-.96-.62-1.81-1.53-2.1ZM2918.72,1519.39c-1.2,0-2.17-.97-2.17-2.16s.97-2.16,2.17-2.16,2.16.97,2.16,2.16-.97,2.16-2.16,2.16Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 2898.69,
    y: 1522.88,
    width: 40.39,
    height: 69.58
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-34",
    x: 2910.44,
    y: 1530.88,
    width: 16.87,
    height: 16.87
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-34",
    x: 2905.49,
    y: 1555.17,
    width: 26.77,
    height: 1.48
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-34",
    x: 2905.49,
    y: 1560.82,
    width: 26.77,
    height: 1.48
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-34",
    x: 2905.49,
    y: 1566.46,
    width: 26.77,
    height: 1.48
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-34",
    x: 2905.49,
    y: 1572.1,
    width: 26.77,
    height: 1.48
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-34",
    x: 2905.49,
    y: 1577.73,
    width: 26.77,
    height: 1.48
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-34",
    x: 2905.49,
    y: 1583.37,
    width: 26.77,
    height: 1.48
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-32",
    points: "2919.46 1510.07 2917.12 1510.07 2916.37 1506.24 2920.2 1506.24 2919.46 1510.07"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M2916.37,1500.1v6.15h3.83v-6.15h-3.83ZM2919.7,1503.43h-2.83v-2.83h2.83v2.83Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 2917.71,
    y1: 1510.07,
    x2: 2918.29,
    y2: 1515.35
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-46",
    points: "2918.1 1515.38 2917.53 1510.09 2917.89 1510.04 2918.47 1515.33 2918.1 1515.38"
  })), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 2919.17,
    y1: 1510.07,
    x2: 2918.59,
    y2: 1515.35
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-46",
    d: "M2920.38,1513.85h-.37c0-.27-.14-.49-.43-.66-.27-.16-.65-.25-1.06-.25-.73,0-1.48.31-1.48.91h-.37c0-.88.96-1.28,1.85-1.28s1.86.41,1.86,1.28Z"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-40",
    points: "2919.69 1502.43 2916.88 1501.48 2960.74 1372.06 2963.55 1373.02 2919.69 1502.43"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-53",
    points: "2917.39 1502.43 2920.2 1501.48 2876.34 1372.06 2873.53 1373.02 2917.39 1502.43"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-44",
    points: "3097.92 1324.55 3066.52 1286.7 3031.05 1312.7 3008.26 1355.24 2928.77 1426.36 2966.26 1477.14 3093.94 1404.26 3097.92 1324.55"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-51",
    points: "2928.77 1426.36 2966.26 1477.14 2907.71 1511.55 2760.89 1332.03 2713.55 1347 2700.14 1319.11 2712.62 1301.91 2663.99 1272.82 2661.42 1257.06 2735.25 1294.72 2760.84 1306.4 2910.39 1418.11 2928.77 1426.36"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M1511.85,2621.37l-53.24,15.86c-3.65,20.8-4.28,24.34-7.93,45.14l44.36,32.85c-8.72,23.96-8.08,22.2-16.8,46.16l-55.12-3.34c-10.57,18.28-12.37,21.4-22.94,39.68l30.55,46.32c-16.38,19.51-15.2,18.1-31.58,37.61l-50.86-22.06c-16.18,13.58-18.93,15.89-35.11,29.48l12.89,53.76c-22.06,12.76-20.46,11.83-42.52,24.58l-40.22-38.06c-19.83,7.22-23.23,8.45-43.06,15.67l-6.36,55.04c-25.1,4.41-23.28,4.09-48.37,8.5l-24.7-49.49c-21.13,0-24.72,0-45.85,0l-24.69,49.49c-25.1-4.41-23.28-4.09-48.37-8.5l-6.36-55.04c-19.83-7.22-23.23-8.45-43.06-15.67l-40.24,38.07c-22.06-12.76-20.46-11.83-42.52-24.58l12.9-53.77c-16.18-13.58-18.93-15.89-35.1-29.48l-50.86,22.05c-16.38-19.51-15.2-18.1-31.58-37.61l30.54-46.32c-10.57-18.28-12.37-21.4-22.94-39.68l-55.1,3.35c-8.72-23.96-8.08-22.2-16.8-46.16l44.36-32.85c-3.65-20.8-4.28-24.34-7.93-45.14l-53.24-15.86c0-25.46,0-23.64,0-49.1l53.24-15.86c3.65-20.8,4.28-24.34,7.93-45.14l-44.36-32.85c8.72-23.96,8.08-22.2,16.8-46.16l55.12,3.34c10.57-18.28,12.37-21.4,22.94-39.68l-30.55-46.32c16.38-19.51,15.2-18.1,31.58-37.61l50.86,22.06c16.18-13.58,18.93-15.89,35.11-29.48l-12.89-53.76c22.06-12.76,20.46-11.83,42.52-24.58l40.22,38.06c19.83-7.22,23.23-8.45,43.06-15.67l6.36-55.04c25.1-4.41,23.27-4.09,48.37-8.5l24.7,49.49c21.13,0,24.72,0,45.85,0l24.69-49.49c25.1,4.41,23.27,4.09,48.37,8.5l6.36,55.04c19.83,7.22,23.23,8.45,43.06,15.67l40.24-38.07c22.06,12.76,20.46,11.83,42.52,24.58l-12.9,53.77c16.18,13.58,18.93,15.89,35.1,29.48l50.86-22.05c16.38,19.51,15.2,18.1,31.58,37.61l-30.54,46.32c10.57,18.28,12.37,21.4,22.94,39.68l55.1-3.35c8.72,23.96,8.08,22.2,16.8,46.16l-44.36,32.85c3.65,20.8,4.28,24.34,7.93,45.14l53.24,15.86c0,25.46,0,23.64,0,49.1Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "cls-49",
    cx: 1098.55,
    cy: 2597.21,
    r: 122.38,
    transform: "translate(-1514.75 1537.5) rotate(-45)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-41",
    cx: 1100.19,
    cy: 2384.21,
    r: 46.08,
    transform: "translate(-1473.02 2907.19) rotate(-76.72)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-41",
    cx: 896.48,
    cy: 2529.84,
    r: 46.08,
    transform: "translate(-1737.37 2013.53) rotate(-59.4)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-41",
    cx: 972.03,
    cy: 2768.58,
    r: 46.08,
    transform: "translate(-421.13 186.14) rotate(-9)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-41",
    cx: 1222.43,
    cy: 2770.49,
    r: 46.08
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-41",
    cx: 1301.64,
    cy: 2532.94,
    r: 46.08,
    transform: "translate(-1409.82 1662.28) rotate(-45)"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M1710.84,2196.7l-33.35,7.89c-5.39,16.57-6.89,21.2-12.28,37.77l22.33,25.98c-14.42,19.83-12.18,16.76-26.6,36.6l-31.61-13.23c-14.1,10.25-18.04,13.11-32.14,23.36l2.81,33.94c-23.33,7.58-19.7,6.4-43.03,13.99l-17.71-29.14c-17.43,0-22.3,0-39.73,0l-17.71,29.15c-23.33-7.58-19.7-6.4-43.03-13.99l2.81-33.95c-14.1-10.25-18.04-13.11-32.14-23.36l-31.61,13.23c-14.42-19.83-12.18-16.76-26.6-36.6l22.33-25.97c-5.39-16.57-6.89-21.2-12.28-37.77l-33.35-7.89c0-24.52,0-20.72,0-45.24l33.35-7.89c5.39-16.57,6.89-21.2,12.28-37.77l-22.33-25.98c14.42-19.83,12.18-16.76,26.6-36.6l31.61,13.23c14.1-10.25,18.04-13.11,32.14-23.36l-2.81-33.94c23.33-7.58,19.7-6.4,43.03-13.99l17.71,29.14c17.43,0,22.3,0,39.73,0l17.71-29.15c23.33,7.58,19.7,6.4,43.03,13.99l-2.81,33.95c14.1,10.25,18.04,13.11,32.14,23.36l31.61-13.23c14.42,19.83,12.18,16.76,26.6,36.6l-22.33,25.97c5.39,16.57,6.89,21.2,12.28,37.77l33.35,7.89c0,24.52,0,20.72,0,45.24Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-41",
    cx: 1519.4,
    cy: 2174.07,
    r: 54.51,
    transform: "translate(-869.98 3325.61) rotate(-80.78)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-36",
    points: "322.58 2114.05 236.22 2114.19 235.2 2205.99 460.26 2328.92 461.12 2253.22 322.58 2114.05"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-39",
    points: "620.67 2107.68 640.31 2095.64 662.46 2095.64 684.67 2130.27 640.31 2170.86 607.87 2141.26 620.67 2107.68"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-54",
    points: "607.84 2141.38 607.87 2141.26 640.31 2170.86 639.96 2171.01 624.89 2189.94 591.77 2156.05 607.84 2141.38"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-36",
    points: "591.77 2156.05 443.27 2255.14 460.26 2328.92 624.89 2189.94 591.77 2156.05"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-51",
    x: 264.6,
    y: 2047.7,
    width: 75.24,
    height: 73.14,
    transform: "translate(-1796.83 1912.44) rotate(-77.07)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-51",
    d: "M282.47,1766.57c95.44-60.75,202.43,3.48,234.65,41.85,31.39,37.37-1.37,95.11-1.37,95.11-6.31,22.07-6.88,27.46-6.88,27.46-.99,9.76,1.75,16.51,8.12,19.48l34.51,16.12c5.38,2.51,5.26,10.2-.19,12.55l-64.37,27.68c-9.41,4.05-17.07,11.31-21.61,20.5l-22.09,44.69c-13.37,27.04-22.18,39.08-52.27,37.03-27.6-1.88-105.04-24.13-139.52-84.59,0,0-113.99-165.55,31.03-257.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M405.44,1857.1c-1.05,36.68-2.1,73.36-3.15,110.04,18.5-.11,36.54,1.25,53.57,8.5,17.02,7.25,31.88,22.09,34.36,40.43.81,6.01-1.35,11.71-6.47,14.95-5.12,3.25-12.4,2.55-16.81-1.61,2.98,14.42,5.03,28.49,2.48,43s-11.96,28.8-26.18,32.65c2.71,15.3-7.83,28.88-21.88,35.52-9.44,4.46-20.46,4.57-30.65,2.33-18.74-4.11-44.23-15.35-55.62-31.4.56-.73,1.15-1.44,1.74-2.14-15.08-5.04-27.78-15.48-32.98-30.94-2.2-6.53-2.84-13.53-2.06-20.36.68-5.95,5.4-12.82,5.22-18.48-.32-10.01-11-18.47-12.16-29.52-1.17-11.12,2.24-22.34,7.62-32.14,5.39-9.8,12.68-18.39,19.93-26.91,18.4-4.54,30.12-24.25,36.83-41.98,6.71-17.73,7.54-37.06,8.29-56,12.59.94,25.32,3.13,37.91,4.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M478.17,1918.22c-3.68,8.41,2.14,17.7,11.31,18.06,5.09.2,10-2.88,12.05-7.55,3.68-8.41-2.14-17.7-11.31-18.06-5.09-.2-10,2.88-12.05,7.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-53",
    d: "M394.38,1946.45c-8.8,21.52,5.88,44.95,29.08,46.42,14.05.89,27.48-7.52,32.81-20.55,8.8-21.52-5.88-44.95-29.08-46.42-14.05-.89-27.48,7.52-32.81,20.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M465.69,2030.83c-18.65-8.01-32.61-25.37-36.42-45.31l3.59-.68c3.58,18.76,16.71,35.1,34.27,42.64l-1.45,3.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M469.14,1907.59l-3.63-.45c.86-7.02,5.55-13.52,11.94-16.53,6.41-3.02,14.38-2.51,20.35,1.3l-1.97,3.09c-4.92-3.15-11.52-3.56-16.82-1.08-5.29,2.5-9.17,7.87-9.87,13.68Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M247.71,2023.06c9.03-21.92,28.28-37.91,48.16-50.83,19.88-12.92,41.31-23.88,58.55-40.16,17.24-16.28,30.63-40.27,27.07-63.71,12.91,3.52,27.29,1.17,38.41-6.25,11.12-7.43,12.92-17.46,14.62-30.73,14.97,8.5,33.1,11.25,49.92,7.57,10.93-2.39,18.73-12.78,28.12-15.18,10.59-2.71,21.43,4.34,33.43-1.06,38.54-17.33,18.94-57.54-4.7-77.84-12.02-10.33-49.48-24.39-58.98-2.92-13.11-24.89-36.13-45.02-63.29-52.38-27.15-7.36-57.29-2.93-81.17,11.94-11.04-12.69-31.79-17.61-47.65-12.02-10.53,3.71-19.25,11.51-25.71,20.62-6.46,9.1-10.84,19.5-14.72,29.96-19.36-1.31-38.82,6.57-49.79,22.58-10.97,16.01-14.85,36.03-14.42,55.43.42,19.4,4.86,38.47,9.27,57.36-2.61-6.19-13.04-4.04-16.82,1.51-3.77,5.56-3.03,12.93-1.81,19.53,9,49.09,32.97,94.89,71.53,126.57Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-51",
    d: "M336.73,1890.72c-7.67-3.23-17.47-.08-21.82,7.02-4.35,7.1-2.7,17.26,3.66,22.62-7.76,4.23-12.02,10.74-12.99,19.53-.97,8.79,2.59,17.96,9.24,23.79-.72-.31-1.44-.63-2.16-.94-3.88,3.6-4.57,6.85-8.45,10.44-6.17-13.17-12.66-25.53-18.83-38.7-5.58-11.9-11.23-24.05-12.85-37.09s1.4-27.36,10.99-36.35c9.49-8.9,24.77-10.92,36.25-4.8s19.07,21.64,16.97,34.48Z"
  })), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-50",
    cx: 325.23,
    cy: 2979.73,
    rx: 210.08,
    ry: 32
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "469.08 2950.92 426.92 2620.67 405.23 2449.83 222.16 2466.36 320.51 2712.99 395.6 2963.21 400.97 2987.03 512.59 2968.36 469.08 2950.92"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-42",
    points: "218.91 2960.83 308.26 2640.11 354.58 2474.24 173.48 2432.2 167.9 2607.73 146.42 2943.63 142.12 2967.67 252.24 2993.79 218.91 2960.83"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-44",
    points: "417.07 2491.7 147.95 2483.81 196.5 2341.93 236.22 2114.19 365.83 2114.19 395.6 2281.95 417.07 2491.7"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "342.62 2114.19 392.5 2281.95 364.65 2114.19 342.62 2114.19"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-38",
    points: "392.5 2281.95 373.2 2217.03 364.09 2146.86 357.97 2132.03 350.49 2140.64 364.65 2114.19 392.5 2281.95"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "393.63 2309.36 332.22 2183.25 340.45 2167.51 320.51 2167.51 322.58 2114.05 329.64 2114.33 327.84 2160.45 352.11 2160.45 340.13 2183.37 399.97 2306.28 393.63 2309.36"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-49",
    x: 852.51,
    y: 2081.3,
    width: 40,
    height: 557.9,
    transform: "translate(-1413.41 1308.28) rotate(-45)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-47",
    cx: 675.26,
    cy: 2163,
    r: 44.24
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-42",
    points: "320.51 2110.84 236.23 2108.74 235.2 2203.36 421.67 2374.8 440.48 2301.46 320.51 2110.84"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-51",
    points: "775.9 2237.83 798.43 2237.83 813.33 2242.14 822.37 2287.31 764.32 2302.97 749.11 2261.78 775.9 2237.83"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "749.03 2261.87 749.11 2261.78 764.32 2302.97 763.95 2302.95 741.86 2312.83 728.02 2267.52 749.03 2261.87"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-42",
    points: "728.02 2267.52 440.48 2301.46 421.67 2374.8 741.86 2312.83 728.02 2267.52"
  }))))), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-46",
    points: "1053.17 2678.65 1006.15 2597.21 1053.17 2515.78 1147.2 2515.78 1194.22 2597.21 1147.2 2678.65 1053.17 2678.65"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-49",
    cx: 1100.19,
    cy: 2597.21,
    r: 46.08,
    transform: "translate(-1514.27 1538.66) rotate(-45)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWebDevelopment);
export default __webpack_public_path__ + "static/media/Web Development.832ab144157b65d73bd9c09026099e27.svg";
export { ForwardRef as ReactComponent };